module.exports = __webpack_public_path__ + "static/media/1.41bf77d6.jpg";